(function () {
  function initWymyFragranceCards() {
    var cards = document.querySelectorAll('[data-wymy-fragrance-card]');
    if (!cards.length) return;

    var toast = document.querySelector('[data-wymy-fragrance-toast]');
    var toastText = toast ? toast.querySelector('[data-wymy-toast-text]') : null;
    var toastTimer = null;

    function showToast(message) {
      if (!toast) return;

      if (toastText) toastText.textContent = message || 'Added to bag.';

      toast.classList.add('is-visible');
      toast.setAttribute('aria-hidden', 'false');

      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
        toast.setAttribute('aria-hidden', 'true');
      }, 2500);
    }

    function updateCartBubble(itemCount) {
      var cartIcon = document.getElementById('cart-icon-bubble');
      if (!cartIcon) return;

      var bubble = cartIcon.querySelector('.cart-count-bubble');

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';

        var countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        bubble.appendChild(countSpan);

        var hiddenSpan = document.createElement('span');
        hiddenSpan.className = 'visually-hidden';
        hiddenSpan.textContent = itemCount + ' items';
        bubble.appendChild(hiddenSpan);

        cartIcon.appendChild(bubble);
      }

      var visibleCount = bubble.querySelector('[aria-hidden="true"]');
      if (visibleCount) visibleCount.textContent = itemCount;
    }

    cards.forEach(function (card) {
      if (card.dataset.wymyBound === 'true') return;
      card.dataset.wymyBound = 'true';

      var sizeButtons = card.querySelectorAll('[data-wymy-size]');
      var price = card.querySelector('[data-wymy-price]');
      var compare = card.querySelector('[data-wymy-compare]');
      var saving = card.querySelector('[data-wymy-saving]');
      var addButton = card.querySelector('[data-wymy-atc]');

      sizeButtons.forEach(function (sizeButton) {
        sizeButton.addEventListener('click', function () {
          sizeButtons.forEach(function (button) {
            button.classList.remove('is-active');
            button.setAttribute('aria-pressed', 'false');
          });

          sizeButton.classList.add('is-active');
          sizeButton.setAttribute('aria-pressed', 'true');

          if (price) price.textContent = sizeButton.dataset.price || '';

          if (compare) {
            if (sizeButton.dataset.compare) {
              compare.textContent = sizeButton.dataset.compare;
              compare.classList.remove('is-hidden');
            } else {
              compare.textContent = '';
              compare.classList.add('is-hidden');
            }
          }

          if (saving) {
            if (sizeButton.dataset.saving) {
              saving.textContent = 'SAVE ' + sizeButton.dataset.saving;
              saving.classList.remove('is-hidden');
            } else {
              saving.textContent = '';
              saving.classList.add('is-hidden');
            }
          }

          if (addButton) {
            addButton.dataset.variantId = sizeButton.dataset.variantId || '';

            var available = sizeButton.dataset.available === 'true';
            addButton.disabled = !available;
            addButton.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
          }
        });
      });

      if (addButton) {
        addButton.addEventListener('click', function () {
          if (addButton.disabled) return;

          var variantId = addButton.dataset.variantId;
          if (!variantId) return;

          var resetText = addButton.textContent;
          addButton.disabled = true;
          addButton.textContent = 'ADDING…';

          var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(variantId),
                quantity: 1
              }]
            })
          })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            return fetch(root + 'cart.js', {
              headers: { 'Accept': 'application/json' }
            });
          })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            updateCartBubble(cart.item_count);
            showToast('Added to bag.');
            addButton.textContent = 'ADDED ✓';

            window.setTimeout(function () {
              addButton.disabled = false;
              addButton.textContent = resetText;
            }, 1100);
          })
          .catch(function () {
            addButton.disabled = false;
            addButton.textContent = resetText;
          });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWymyFragranceCards);
  } else {
    initWymyFragranceCards();
  }

  document.addEventListener('shopify:section:load', initWymyFragranceCards);
})();
